import styles from './CheckoutPreview.module.css';
import { TEnabledOptions } from '../../../../Buyer/hooks/useEnabledTerms';
import { PaymentDetails } from '../../../../Buyer/PayLinkLanding/PaymentDetails/PaymentDetails';
import {
  TBuyerInterest,
  TPricingPromotions,
  TRepresentativeInterest,
} from '../../../../Buyer/PayLinkLanding/utils/PayLinkLanding.types';

export const CheckoutPreview = ({
  sellerName,
  amount,
  reference,
  pricingPromotions,
  representativeInterest,
}: {
  sellerName: string;
  amount?: number | string;
  reference?: string;
  pricingPromotions: TPricingPromotions;
  representativeInterest: TRepresentativeInterest;
}) => {
  const enabledOptions = ['THREE_MONTHS', 'PAY_NOW'];

  if (representativeInterest.TWELVE_MONTHS !== undefined) {
    enabledOptions.push('TWELVE_MONTHS');
  }

  // Construct buyerInterest only using rep rate (no formal offers in preview)
  const buyerInterest = {
    THREE_MONTHS: {
      rate: representativeInterest.THREE_MONTHS,
      type: 'representative',
      isSellerPays: representativeInterest.THREE_MONTHS === 0,
    },
    ...(representativeInterest?.TWELVE_MONTHS !== undefined && {
      TWELVE_MONTHS: {
        rate: representativeInterest.TWELVE_MONTHS,
        type: 'representative',
        isSellerPays: representativeInterest.TWELVE_MONTHS === 0,
      },
    }),
  } as TBuyerInterest;

  return (
    <>
      <h2 className={styles.tag}>Customer Preview</h2>
      <div className={styles.previewWrapper} data-testid="checkoutPreview">
        <PaymentDetails
          sellerName={sellerName!}
          pricingPromotions={pricingPromotions}
          buyerInterest={buyerInterest}
          initialValues={{ amount: (amount || '').toString(), reference }}
          enabledOptions={enabledOptions as TEnabledOptions}
          payLinkType="preview"
        />
      </div>
    </>
  );
};
